import { getDateTimeParts } from './get-date-time-parts.mjs';
import { isSameMonth } from './is-same-month.mjs';

function isSameDay(date1, date2, timeZone) {
  const {
    day: day1
  } = getDateTimeParts(date1, timeZone);
  const {
    day: day2
  } = getDateTimeParts(date2, timeZone);
  return isSameMonth(date1, date2, timeZone) && day1() === day2();
}

export { isSameDay };
